"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailTicketConverter = exports.TicketSoporteConverter = void 0;
const generarCampoBusqueda_1 = require("../utils/generarCampoBusqueda");
exports.TicketSoporteConverter = {
    toFirestore(ticketSoporte) {
        const obj = ticketSoporte;
        const buscableExactoPor = [];
        if (Array.isArray(ticketSoporte.mails)) {
            for (const mail of ticketSoporte.mails) {
                const rutCuerpoTexto = buscarRut(mail.cuerpoTexto);
                if (rutCuerpoTexto.length > 0) {
                    for (const rut of rutCuerpoTexto) {
                        buscableExactoPor.push(rut);
                    }
                }
                const rutAsunto = buscarRut(mail.asunto);
                if (rutAsunto.length > 0) {
                    for (const rut of rutAsunto) {
                        buscableExactoPor.push(rut);
                    }
                }
                for (const adjunto of mail.adjuntos) {
                    const rutNombreArchivos = buscarRut(adjunto.nombre);
                    if (rutNombreArchivos.length > 0) {
                        for (const rut of rutNombreArchivos) {
                            buscableExactoPor.push(rut);
                        }
                    }
                }
            }
        }
        if (ticketSoporte.asunto != "" && ticketSoporte.asunto != null)
            buscableExactoPor.push(ticketSoporte.asunto);
        if (ticketSoporte.numero != null && ticketSoporte.numero != 0)
            buscableExactoPor.push(ticketSoporte.numero.toString());
        if (ticketSoporte.mails && ticketSoporte.mails.length > 0) {
            for (const mail of ticketSoporte.mails) {
                if (mail.correosReceptor.length > 0) {
                    for (let m of mail.correosReceptor) {
                        if (m != "" && m != null && m != "soporte@fixed.uy")
                            buscableExactoPor.push(m);
                    }
                    for (let m of mail.correosCopia) {
                        if (m != "" && m != null && m != "soporte@fixed.uy")
                            buscableExactoPor.push(m);
                    }
                }
            }
        }
        if (buscableExactoPor.length > 0) {
            obj.query = (0, generarCampoBusqueda_1.generarCampoBusqueda)({ buscableParcialPor: buscableExactoPor, buscableExactoPor: [] });
        }
        return obj;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            version: data.version,
            activo: data.activo,
            destacado: data.destacado,
            hayEnviado: data.hayEnviado ?? false,
            autor: data.autor,
            respondiendoActual: data.respondiendoActual,
            asunto: data.asunto,
            fecha: data.fecha,
            fechaUltimoMail: data.fechaUltimoMail,
            correoFixed: data.correoFixed,
            correosCliente: data.correosCliente,
            mails: data.mails,
            mailsId: data.mailsId,
            asignado: data.asignado,
            leido: data.leido,
            estado: data.estado,
            prioridad: data.prioridad,
            historial: data.historial,
            numero: data.numero,
            viendo: data.viendo,
            respondiendo: data.respondiendo,
            buscablePor: data.buscablePor ?? [],
            casillaCorreo: data.casillaCorreo
        };
    }
};
exports.MailTicketConverter = {
    toFirestore(mailTicket) {
        return mailTicket;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            version: data.version,
            autor: data.autor,
            correoEmisor: data.correoEmisor,
            correosReceptor: data.correosReceptor,
            correosCopia: data.correosCopia,
            asunto: data.asunto,
            cuerpoTexto: data.cuerpoTexto,
            enviado: data.enviado,
            fechaEnvio: data.fechaEnvio,
            leido: data.leido,
            adjuntos: data.adjuntos,
            imagenesCuerpoTexto: data.imagenesCuerpoTexto,
            notaPrivada: data.notaPrivada,
            mailPadreId: data.mailPadreId,
            references: data.references,
            procesoAutomatico: data.procesoAutomatico
        };
    }
};
function buscarRut(texto) {
    const rutRegex = /\d{12}/g; // Busca cualquier secuencia de 12 números seguidos
    const coincidencias = texto.match(rutRegex);
    return coincidencias ? coincidencias : [];
}
